export default function AlbumCover({ album, className, alt, size }) {
  const { webp, png } = album.cover;
  const style = size ? { width: size, height: size } : undefined;
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${webp.x1} 1x, ${webp.x2} 2x`}
      />
      <source
        type="image/png"
        srcSet={`${png.x1} 1x, ${png.x2} 2x`}
      />
      <img
        src={png.x1}
        alt={alt || `${album.title} — ${album.artist}`}
        className={className}
        style={style}
        loading="lazy"
        decoding="async"
      />
    </picture>
  );
}
